import styled, { keyframes } from 'styled-components';

const EaseIn = keyframes`
  from{ opacity:0; }
  to{ opacity:1; }
`;

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
    margin-top: 52px;
  }

  .TitleContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media only screen and (max-width: 1100px) {
      align-items: center;
    }
  }

  .CardContainer1 {
    margin-top: 20px;
    @media only screen and (max-width: 1100px) {
      margin-top: 190px;
    }
    @media only screen and (max-width: 767px) {
      margin-top: 250px;
    }

    @media only screen and (max-width: 635px) {
      margin-top: 320px;
    }

    @media only screen and (max-width: 374px) {
      margin-top: 370px;
    }
  }

  .CardContainer {
    margin-top: 20px;
    @media only screen and (max-width: 1100px) {
      margin-top: 20px;
    }
  }

  .buttonsContainer {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media only screen and (max-width: 767px) {
      justify-content: center;
    }

    .white {
      border: 2px solid var(--purple);
      background: var(--white);
      color: var(--purple);
      border-radius: 17px;

      &:hover {
        color: var(--white);
        background: var(--purple);
      }
    }

    .purple {
      background: var(--purple);
      color: var(--white);
      border-radius: 17px;
      border: 2px solid var(--purple);

      &:hover {
        border: 2px solid var(--purple);
        color: var(--purple);
        background: var(--white);
      }
    }
    button {
      margin-right: 5px;
    }
  }

  .labelContainer {
    display: flex;
  }

  .activeLabel {
    color: var(--white);
    padding: 5px;
    border-radius: 5px;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    height: 27px;
    margin-right: 10px;
  }

  .activeLabel.green {
    background: var(--green);
  }

  .activeLabel.gray {
    background: var(--text);
  }

  .buttons {
    display: flex;
    button {
      display: flex;
      align-items: center;
      margin-right: 10px;
      transition: background 0.3s ease;

      &:hover {
        background: #b14729;
      }
    }
  }

  .tarifaOptions {
    transition: all 0.3s ease;
    animation: ${EaseIn} 0.5s;
  }

  .title {
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 28px;

    color: var(--purple);
  }

  .codeText {
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    color: var(--orange);
  }

  .text {
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 28px;

    color: var(--purple);
  }

  .cardLink {
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    border-bottom: 1px solid var(--purple);
    color: var(--purple);
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;
  color: var(--orange);
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 1100px) {
    flex-direction: column-reverse;
    text-align: center;
    margin-top: -30px;
  }
  @media only screen and (max-width: 767px) {
    margin-top: -30px;
  }
`;

export const SubTitle = styled.p`
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;

  color: #000000;
`;

export const Card = styled.div`
  display: flex;
  background: #ebf1f4;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 24px;
  padding: 35px;
  margin-top: 24px;

  @media only screen and (max-width: 1100px) {
    flex-direction: column;
  }

  .CardTitle {
    width: 18%;
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 37px;
    color: #452359;
    @media only screen and (max-width: 1100px) {
      width: 100%;
    }
  }

  .CardForm {
    width: 100%;
  }

  .CardForm.CardLink {
    width: 100%;
    margin-top: 4px;
  }
`;
export const BtnCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  width: 100%;

  Button + Button {
    margin-left: 50px;
  }

  .btn-remover {
    color: #e6273d;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    height: 50px;
  }
  .btn {
    color: black;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    height: 50px;
  }
`;
export const FlexRow = styled.div`
  justify-content: center;
  align-items: center;
  align-self: center;
  margin-top: 30px;

  .flex-start {
    display: flex;
    justify-content: flex-start;
    align-self: flex-start;
    width: 60%;
  }

  .greyBackground {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    background-color: #e8e8e8;
    padding: 5px;
    align-items: center;
    display: flex;
    height: 40px;
  }

  .content {
    margin-left: 40px;
  }
  .row {
    display: flex;
    margin-top: 10px;

    .link {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .column {
    display: flex;
    flex-direction: column;
    margin-top: 10px;

    margin-right: 60px;
    div + div {
      margin-top: 5px;
    }
  }

  .ativo {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #43a047;
    color: white;
    padding: 2px;
    width: 90px;
  }

  .inativo {
    color: var(--black);
    background-color: #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    width: 90px;
  }
  .content-left {
    width: 40%;
  }

  .content-right {
    margin-left: 60px;
    width: 40%;
  }
  .align-right {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    align-self: flex-end;
    width: 40%;
  }
  .btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    .btn {
      color: #757575;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      width: 50%;
    }
    .btnconf {
      width: 50%;
    }
  }

  .btn-remover {
    color: #e6273d;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    width: 50%;
  }

  Button + Button {
    margin-left: 40px;
  }
  Button {
    height: 50px;
  }
`;
